import { useState } from "react";
import type { PublicClientApplication } from "@azure/msal-browser";
import { randomString } from "plg/auth/googlePkce";
import { savePendingSso } from "plg/auth/ssoRedirect";

const MS_LOGO = (
  <svg viewBox="0 0 23 23" aria-hidden="true">
    <path fill="#F35325" d="M1 1h10v10H1z" />
    <path fill="#81BC06" d="M12 1h10v10H12z" />
    <path fill="#05A6F0" d="M1 12h10v10H1z" />
    <path fill="#FFBA08" d="M12 12h10v10H12z" />
  </svg>
);

interface Props {
  /** The PLG Microsoft app (usePlgMsal); null until it is ready or without a client id. */
  msal: PublicClientApplication | null;
  disabled?: boolean;
}

/** Continue with Microsoft: leaves for Microsoft in this tab; the sign-in page finishes when it comes back. */
function MicrosoftSsoButton({ msal, disabled }: Props) {
  const [leaving, setLeaving] = useState(false);
  const handleClick = async () => {
    if (!msal || leaving) return;
    setLeaving(true);
    const nonce = randomString(16);
    savePendingSso({ provider: "microsoft", nonce });
    try {
      await msal.loginRedirect({ scopes: ["openid", "profile", "email"], nonce, prompt: "select_account" });
    } catch {
      // Could not leave (e.g. a sign-in already in progress): the visitor can click again.
      setLeaving(false);
    }
  };

  return (
    <button type="button" className="plg-sso-btn" onClick={handleClick} disabled={disabled || leaving || !msal}>
      {MS_LOGO}
      Continue with Microsoft
    </button>
  );
}

export default MicrosoftSsoButton;
